import React from 'react';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { FeaturedProjects } from '../components/FeaturedProjects';
import { ContactBand } from '../components/ContactBand';
export function Home() {
  return <>
      <Hero data-id="element-335" />
      <Stats data-id="element-336" />
      <FeaturedProjects data-id="element-337" />
      <ContactBand data-id="element-338" />
    </>;
}